import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AppBanner from '../../components/AppBanner';
import { trackCloseAppBanner, trackVisitAppBanner } from '../../actions/tracking/apps';
import getPlatform from '../../utils/getPlatform';

export class AppBannerContainer extends React.Component {
  platform = getPlatform(this.props.userAgent);

  getRating() {
    switch (this.platform) {
      case 'android':
        return this.props.ratings.googleRating;
      case 'ios':
        return this.props.ratings.itunesRating;
      default:
        return false;
    }
  }

  getReviews() {
    switch (this.platform) {
      case 'android':
        return this.props.ratings.googleCount;
      case 'ios':
        return this.props.ratings.itunesCount;
      default:
        return false;
    }
  }

  render() {
    if (!this.platform) {
      return null;
    }
    return (
      <AppBanner
        trackVisitAppBanner={this.props.trackVisitAppBanner}
        trackCloseAppBanner={this.props.trackCloseAppBanner}
        rating={this.getRating()}
        reviews={this.getReviews()}
        platform={this.platform}
        page={this.props.page}
      />
    );
  }
}

AppBannerContainer.propTypes = {
  userAgent: PropTypes.string,
  ratings: PropTypes.shape({
    googleRating: PropTypes.number,
    itunesRating: PropTypes.number,
    googleCount: PropTypes.string,
    itunesCount: PropTypes.string,
  }),
  page: PropTypes.string.isRequired,
  trackCloseAppBanner: PropTypes.func.isRequired,
  trackVisitAppBanner: PropTypes.func.isRequired,
};

AppBannerContainer.defaultProps = {
  ratings: {},
  userAgent: undefined,
};

export default connect(
  (state) => ({
    userAgent: state.request.userAgent,
    ratings: state.request.country.appRatings,
  }),
  (dispatch) => ({
    trackCloseAppBanner: () => dispatch(trackCloseAppBanner()),
    trackVisitAppBanner: () => dispatch(trackVisitAppBanner()),
  }),
)(AppBannerContainer);
